<script>
	import { onMount } from 'svelte';
	import { getText, jumpByAnchor } from '../../../../share/utils';

	let div_headquarter;

	onMount(() => {
		jumpByAnchor(div_headquarter);
	});
</script>

<div class="page-agency--office marginbox">
	<div class="img-single">
		<img loading="lazy" alt="Agentur - Rooftop" src="./img/02.Agentur/02.office-view/rooftop.webp">
	</div>

	<div bind:this={div_headquarter} id="headquarter" class="flex structure">
		<div class="flex col structure-1">
			<div class="flex element">
				<div class="text">
					<h2>{getText("02.02.01_h2")}</h2>
					<p class="caption">{getText("02.02.02_caption")}</p>
				</div>
			</div>

			<div class="flex element">
				<img loading="lazy" alt="Agentur - Trophy" src="./img/02.Agentur/02.office-view/trophy.webp">
			</div>

			<div class="flex element right">
				<div class="text">
					<h2>{getText("02.02.03_h2")}</h2>
					<p class="caption">{getText("02.02.04_caption")}</p>
				</div>
			</div>

			<div class="flex col element text overflow">
				<h2 class="balance">{getText("02.02.05_quote")}</h2>
				<h2 class="imageoverlay balance">{getText("02.02.05_quote")}</h2>
				<p class="caption">Markus Grabher</p>
			</div>
		</div>

		<div class="flex col structure-2">
			<div class="flex row">
				<div class="flex element">
					<img loading="lazy" alt="Agentur - Entrance" src="./img/02.Agentur/02.office-view/door.webp">
				</div>

				<div class="flex element">
					<img loading="lazy" alt="Agentur - Indoor" src="./img/02.Agentur/02.office-view/indoor.webp">
				</div>
			</div>

		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";

	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}

	.img-single {
		margin: $spacing-mobile 0 $media-gap 0;
	}

	.right {
		text-align: right;

		@include for-tablet-landscape-up {
			justify-content: end;
		}
	}

	.page-agency--office {
		h2 {
			margin-bottom: $media-gap;

			&.imageoverlay {
				position: absolute;
			}
		}

		.flex {
			display: flex;
			box-sizing: border-box;
		}

		.row {
			flex-flow: row wrap;
		}

		.col {
			flex-flow: column wrap;
		}

		.element {
			min-width: 100px;
			/*align-self: center;*/
		}

		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}

		.content {
			flex: 1 100%;
		}

		.structure {
			flex-flow: row wrap;
			margin: $spacing-mobile 0;
			justify-content: space-between;

			@include for-desktop-up {
				flex-flow: row nowrap;
			}
		}

		.structure-1 {
			flex-shrink: 1;
			width: auto;
			margin-top: $spacing-mobile;
			margin-bottom: $media-gap;

			@include for-tablet-portrait-up {
				width: 50%;
				margin-top: 0;
				padding-right: $media-gap;
			}

			.element:first-of-type {
				@include for-tablet-portrait-up {
					margin-bottom: $spacing-mobile*2.5;
					padding-right: 30%;
				}
			}

			.element:nth-of-type(2) {
				margin-bottom: $media-gap;
			}

			.element:nth-of-type(3) {
				@include for-tablet-portrait-up {
					padding-left: 30%;
				}
			}

			.col.text {
				// blend with image laying in background:
				position: relative;

				h2 {
					margin-bottom: 0;
					z-index: -1;
					color: #0c0c0c;

					&.imageoverlay {
						position: absolute;
						z-index: 10 !important;
						color: #EEE !important;
						mix-blend-mode: color-dodge;
						left: 0;
						top: 0;
					}
				}
			}
		}

		.structure-2 {
			flex-shrink: 0;
			width: 100%;
			justify-content: start;
			z-index: 1;

			@include for-tablet-portrait-up {
				align-self: flex-start;
				width: 50%;
			}

			.element:first-child {
				margin-bottom: $media-gap;
			}
		}

		.text {
			margin-bottom: $media-gap;

			&.overflow * {
				@include for-tablet-portrait-up {
					width: 150%;
					z-index: 1;
				}
			}
		}
	}
</style>
